import { request } from "@/common/api";
import { Contact } from "@/common/types/inquiry";
import { Buttons } from "@/components/atoms/Buttons";
import { Loading } from "@/components/atoms/Loading";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { GET_CONTACT } from "@/common/querykeys";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { useRecoilValue } from "recoil";
import { InquiryContactItem } from "@/components/atoms/InquiryContactItem";
import { InquiryContactList } from "@/components/molecules/InquiryContactList";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import {
  guardianUserState,
  loginTypeState,
  studentUserState,
} from "@/common/states/user";

export const InquiryContactPage = () => {
  /** 🛣️ Navigation Capability Acquisition */
  const navigate = useNavigate();

  /** 📦 State Store */
  const student = useRecoilValue(studentUserState);
  const guardian = useRecoilValue(guardianUserState);
  const loginType = useRecoilValue(loginTypeState);

  /** 📡 API Layer */
  // 1:1 문의 글 데이터 조회
  const { data: inquiry, isPending } = useQuery<Contact[]>({
    queryKey: [GET_CONTACT],
    queryFn: async () => {
      return await request<Contact[]>({
        method: "GET",
        url: `/inquiry/${loginType === "student" ? student.id : guardian.id}`,
      });
    },
  });

  return (
    <MainTemplate
      nav={false}
      subPage={false}
      menuBtn={false}
      pageTitle="1:1 문의"
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="뒤로"
          onClick={() => navigate("/setting/inquiry")}
        />
      }
    >
      <InquiryContactList>
        {isPending ? (
          <Loading />
        ) : (
          <>
            {/* inquiry 데이터가 존재하면 InquiryItem 리스트로 렌더링 */}
            {inquiry && inquiry.length > 0 ? (
              inquiry.map((item: any) => (
                <InquiryContactItem key={item.contactId} data={item} />
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  minHeight: "300px",
                  fontSize: "1.4rem",
                  fontWeight: "400",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                1:1 문의 내역이 없습니다.
              </div>
            )}
          </>
        )}
      </InquiryContactList>
    </MainTemplate>
  );
};
